<template>
    <div>
        <h1 style="font-size: 24px; color: black;">反馈列表</h1>
        <el-tabs type="card" v-model="position" @tab-click="changeIndex" >
            <el-tab-pane v-for="position in positions"  :name="position.id+''" :key="position.id" :label="position.name">
            </el-tab-pane>
        </el-tabs>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="反馈ID：">
                    <el-input  placeholder="请输入内容"  v-model="queryData.id" ></el-input>
                </el-form-item>
                <el-form-item label="用户DID：">
                    <el-input  placeholder="请输入内容"  v-model="queryData.did" ></el-input>
                </el-form-item>
                <el-form-item v-if="position ==='0' || position ==='2'" label="联系方式：" >
                    <el-input v-if="position ==='0' || position ==='2'" placeholder="请输入内容"  v-model="queryData.contact" ></el-input>
                </el-form-item>
                <el-form-item label="游戏ID：" v-if="position==='1' ">
                    <el-input v-if="position==='1' " placeholder="请输入内容"  v-model="queryData.gid" ></el-input>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="queryData.state" placeholder="请选择"  >
                        <el-option v-for="state in states"
                                   :key="state.id"
                                   :label="state.name"
                                   :value="state.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="queryFeedback">查询</el-button>
                    <el-button @click="reset">重置</el-button>
                    <el-button type="success" @click="exportExcel">导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="feedback"
                      style="width: 100%"
                      border
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="反馈ID" prop="id" align="center"></el-table-column>
                <el-table-column label="用户ID" prop="did" align="center"></el-table-column>
                <el-table-column label="反馈内容"  align="center" show-overflow-tooltip>
                    <template slot-scope="scope" >
                        {{ scope.row.suggest !==null ? scope.row.suggest:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column v-if="position === '0' && loading ===false" label="联系方式"   align="center" >
                    <template slot-scope="scope" v-if="position === '0' ">
                        {{ scope.row.contact !==null ? scope.row.contact:"暂无"}}
                    </template>
                </el-table-column>

                <el-table-column  v-if="position === '1' && loading ===false" label="游戏ID"   align="center">
                    <template slot-scope="scope" v-if="position === '1' ">
                        {{ scope.row.gid !==null ? scope.row.gid:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column  v-if="position === '1' && loading ===false" label="游戏名"   align="center">
                    <template slot-scope="scope" v-if="position === '1' ">
                        {{ scope.row.gameName !==null ? scope.row.gameName:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="手机品牌"  align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.ph !==null ? scope.row.ph:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="手机型号" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.pt !==null ? scope.row.pt:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="手机系统"  align="center" >
                    <template slot-scope="scope" >
                        {{ scope.row.sv !==null ? scope.row.sv:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="网络环境"  align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.nt !==null ? scope.row.nt:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="版本号" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.version_code !==null ? scope.row.version_code:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="版本名" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.version_name !==null ? scope.row.version_name:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="包名" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.pack !==null ? scope.row.pack:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="子渠道" align="center">
                    <template slot-scope="scope" >
                        {{ scope.row.scid !==null ? scope.row.scid:"暂无"}}
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template slot-scope="scope" >
                        <el-button v-if="scope.row.state===0" type="primary" plain @click="updateState(scope.row.id,1)">待处理</el-button>
                        <el-button v-if="scope.row.state===1" plain disabled>已处理</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center">
                    <template slot-scope="scope" >
                        {{formatDate(scope.row.create_dt,"yyyy-MM-DD HH:mm:ss")}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        downloadData,
        feedbackSearch,
        feedbackUpdate
    } from "@/http/api";
    import utils from '@/utils';
    export default {
        name: "Feedback",
        data(){
            return{
                position:0,
                queryData:{
                    gid:-1,
                    did:'',
                    timeDate:['',''],
                    id:'',
                    state: -1,
                    contact:'',
                    isExport:0,
                    orders:'create_dt desc',
                },
                page: {
                    size: 20,
                    page: 1,
                    totalElements: null
                },
                feedback:[],
                loading:true,
                positions:[
                    {id:0,name:'用户反馈'},
                    {id:1,name:'游戏反馈'},
                    {id:2,name:'ios反馈'},
                ],
                states:[
                    {id:-1,name:'全部'},
                    {id:0,name:'待处理'},
                    {id:1,name:'已处理'}
                ]
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            changeIndex: function(tab){
                if(tab.name==='0'){
                    this.queryData.gid=-1;
                }else if (tab.name==='2'){
                    this.queryData.gid=-2;
                } else{
                    this.queryData.gid='';
                }
                this.queryFeedback();
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryFeedback();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryFeedback();
            },
            updateState(id,state){
                this.$confirm('确认是否通过?', '警告', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    feedbackUpdate(id,state).then(resp=> {
                        if (resp.data.status===0){
                            this.$message({
                                message: "操作成功",
                                type: 'success'
                            });
                            this.queryFeedback();
                        }else{
                            this.$message({
                                message: "操作失败",
                                type: 'error'
                            });
                        }
                    })
                })
            },
            queryFeedback(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.contact = (this.queryData.gid ===-1 || this.queryData.gid ===-2) ? this.queryData.contact : '';
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.queryData.isExport = 0;
                const numReg = /^[0-9]*$/;
                const numRe = new RegExp(numReg);
                let _message = '';
                if(this.position ==='1' && !numRe.test(this.queryData.gid)){
                    _message = '游戏id为数字，请输入数字！'
                }if(!numRe.test(this.queryData.id)){
                    _message ="反馈id为数字，请输入数字! "
                }
                if (_message) {
                    this.$message({
                        type: 'error',
                        message: _message,
                    });
                    return false
                }
                this.loading = true;
                feedbackSearch(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.feedback=resp.data.info.list;
                        this.page.totalElements =resp.data.info.totalElements;
                    }
                });
            },
            reset(){
                if (this.position === '0'){
                    this.queryData.gid = -1;
                    this.queryData.did = '';
                    this.queryData.timeDate=['',''];
                    this.queryData.id='';
                    this.queryData.state=-1;
                    this.queryData.contact='';
                    this.queryData.isExport=0;
                    this.queryData.orders='create_dt desc';
                    }
                else if (this.position === '2'){
                    this.queryData.gid = -2;
                    this.queryData.did = '';
                    this.queryData.timeDate=['',''];
                    this.queryData.id='';
                    this.queryData.state=-1;
                    this.queryData.contact='';
                    this.queryData.isExport=0;
                    this.queryData.orders='create_dt desc';
                    }
                else {
                    this.queryData.gid = '';
                    this.queryData.did = '';
                    this.queryData.timeDate=['',''];
                    this.queryData.id='';
                    this.queryData.state=-1;
                    this.queryData.contact='';
                    this.queryData.isExport=0;
                    this.queryData.orders='create_dt desc';
                }
            },
            exportExcel() {
                let fileName;
                if(this.queryData.gid ===-1){
                    fileName  = new Date().toLocaleString() + '_用户反馈.xlsx';
                }else if (this.queryData.gid ===-2){
                    fileName  = new Date().toLocaleString() + '_ios反馈.xlsx';
                } else {
                    fileName  = new Date().toLocaleString() + '_游戏反馈.xlsx';
                }
                this.queryData.isExport = 1;
                console.log(this.queryData);
                downloadData(
                    '/feedback/exportExcel',
                    Object.assign(this.queryData),
                    fileName
                )
            }
        },
        created () {
            this.queryFeedback();
        }
    }
</script>

<style scoped>
    .sub-sub10{ position: relative; left: 150px}
</style>